import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { Dispatch } from 'src/app/classes/dispatch';
import { DispatchDriverSummary } from 'src/app/classes/dispatch-driver-summary';
import { DispatchFilterParams } from 'src/app/classes/dispatch-filter-params';
import { DispatchTaskGroupSummary } from 'src/app/classes/dispatch-task-group-summary';
import { DispatchUpdateResponse } from 'src/app/classes/dispatch-update-response';
import { TaskType } from 'src/app/classes/task-type-enum';
import { DispatchService } from 'src/app/services/dispatch.service';
import { EventsService } from 'src/app/services/events.service';
import { ToastService } from 'src/app/services/toast.service';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { PreferredDriversDialogComponent } from '../../preferred-drivers-dialog/preferred-drivers-dialog.component';

@Component({
  standalone: false,
  selector: 'app-dispatch-preferred-drivers',
  templateUrl: './dispatch-preferred-drivers.component.html',
  styleUrls: [ './dispatch-preferred-drivers.component.scss' ]
})
export class DispatchPreferredDriversComponent implements OnInit, OnDestroy {
  @Output() updateTask = new EventEmitter<DispatchUpdateResponse>();

  preferredDriversList: string[] = [];
  driverSummaryList: DispatchDriverSummary[] = [];

  TaskType = TaskType;

  subs = new Subscription();

  constructor(
    readonly dialog: MatDialog,
    readonly utilityService: UtilitiesService,
    readonly dispatchService: DispatchService,
    private eventsService: EventsService,
    private toastService: ToastService
  ) {}

  ngOnInit(): void {
    this.subs.add(this.subToDispatchData());
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  subToDispatchData(): Subscription {
    return this.dispatchService.getDispatchData().subscribe((dispatchData: Dispatch) => {
      if (dispatchData) {
        this.driverSummaryList = dispatchData.driverSummaryList || [];
        this.preferredDriversList = (dispatchData.preferredDriversList || [])
          .map((driver: string) => driver.toUpperCase());
      }
    });
  }

  openPreferredDriversList(): void {
    this.dialog.open(PreferredDriversDialogComponent, {
      width: '300px',
      data: {
        preferredDriversList: this.preferredDriversList,
        driverSummaryList: this.driverSummaryList
      },
      disableClose: false
    });
  }

  timeMath(thisDate: string): string[] {
    return this.utilityService.timeMath(thisDate);
  }

  filterByDriver(driver: DispatchDriverSummary): void {
    const params: DispatchFilterParams = this.dispatchService.dispatchFilterParams.getValue() || {
      driver: '',
      date: '',
      hoursOffset: 0,
      searchText: '',
      type: ''
    };

    params.driver = driver.driverId;
    params.type = [
      'Unassigned',
      'Assigned',
      'Started',
      'Completed',
      'Cancelled',
      'InboundFlight',
      'OutboundFlight',
      'Other',
      'RemoteParking',
      'Terminal'
    ];

    this.dispatchService.dispatchFilterParams.next(params);
    this.dispatchService.triggerDispatchUpdate();
    this.dispatchService.isDispatchFilterOn = true;
  }

  dropAssignToDriver(event: CdkDragDrop<DispatchDriverSummary, any, DispatchTaskGroupSummary>): void {
    const driver: DispatchDriverSummary = event.container.data;
    if (!driver.van) {
      this.toastService.show('Selected driver does not have a van assigned.', { classname: 'bg-danger text-light', delay: 8000 });
      return;
    }
    this.dispatchService
      .dropAssignTask(event.item.data, driver)
      .subscribe((response) => {
        this.updateTask.emit(response);
        this.eventsService.triggerEventsUpdate();
      });
  }

  driverIsPreferred(driver: DispatchDriverSummary): boolean {
    return this.preferredDriversList
      .map((preferredDriverId: string) => preferredDriverId.toUpperCase())
      .includes(driver.driverId.toUpperCase());
  }
}
